import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInboxFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Inbox",
	width: 24,
	height: 25,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.755 9.46777H15.245C15.659 9.46777 15.995 9.80377 15.995 10.2178C15.995 10.6318 15.659 10.9678 15.245 10.9678H8.755C8.341 10.9678 8.005 10.6318 8.005 10.2178C8.005 9.80377 8.341 9.46777 8.755 9.46777ZM10.674 6.13777H13.326C13.74 6.13777 14.076 6.47377 14.076 6.88777C14.076 7.30177 13.74 7.63777 13.326 7.63777H10.674C10.26 7.63777 9.924 7.30177 9.924 6.88777C9.924 6.47377 10.26 6.13777 10.674 6.13777ZM7.288 13.0448C8.47 13.0448 9.528 13.7038 10.052 14.7638C10.421 15.5108 11.167 15.9758 11.998 15.9758C12.83 15.9758 13.575 15.5108 13.944 14.7638C14.468 13.7038 15.526 13.0448 16.708 13.0448H21.3C21.4105 13.0448 21.5 12.9552 21.5 12.8448V8.05277C21.5 4.73777 19.377 2.50977 16.217 2.50977H7.782C4.623 2.50977 2.5 4.73777 2.5 8.05277V12.8448C2.5 12.9552 2.58954 13.0448 2.7 13.0448H7.288Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.7081 14.5447C16.1021 14.5447 15.5591 14.8827 15.2901 15.4267C14.6661 16.6907 13.4051 17.4757 11.9981 17.4757C10.5931 17.4757 9.33106 16.6907 8.70706 15.4277C8.43706 14.8827 7.89506 14.5447 7.28806 14.5447H2.70006C2.5896 14.5447 2.50006 14.6342 2.50006 14.7447V16.0267C2.50006 19.3427 4.62306 21.5707 7.78206 21.5707H16.2161C19.3761 21.5707 21.5001 19.3427 21.5001 16.0267V14.7447C21.5001 14.6342 21.4105 14.5447 21.3001 14.5447H16.7081Z",
		fill: "currentColor"
	})]
});
export default SvgInboxFill;
